import { useContext } from 'react';
import useCURD_Queries from '../queryGenerals/useCURD_Queries';
import { GlobalContext } from '../../../App';
import { updateOrAddItem, useAddData, useGetDataByName, useUpdateData } from '../../dataLocal/indexedDBHooks';
import { DataContext } from '../../../new_version/pages/pagesMains/GravesManagers/Graves';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('שגיאה בקבלת כתובת IP:', error);
    return null;
  }
};

const useBurialQueries = () => {
  const { userId, setDataBurials, db } = useContext(GlobalContext);
  const context = useContext(DataContext);
  const { AllDataEntities, addOrUpdateDataEntity2, removeEntity } = useCURD_Queries();

  const addData = useAddData(db, 'myStore');
  const updateData = useUpdateData(db, 'myStore');
  const getDataByName = useGetDataByName(db, 'myStore');

  const AllDataBurials = async () => {
    try {
      let query = `api/burials/getBurials`;
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
      let nameEntity = 'dataBurials';

      const data = await AllDataEntities(url); // המתנה לתוצאה

      setDataBurials(data?.resData || []);
      if (db) {
        getDataByName(nameEntity)
          .then((existingData) => {
            if (existingData.length > 0) {
              // אם הנתונים קיימים, עדכן אותם
              updateData({ id: 9, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Updated Data:', data);
                })
                .catch((error) => console.error('Error updating data:', error));
            } else {
              // אם הנתונים לא קיימים, הוסף אותם
              addData({ id: 9, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Added Data:', data);
                })
                .catch((error) => console.error('Error adding data:', error));
            }
          })
          .catch((error) => console.error('Error getting data by name:', error));
      }
    } catch (error) {
      console.error('שגיאה בטעינת נתונים: ', error);
    }
  };

  const addOrUpdateDataBurial = async (data, unicId) => {
    let create = `api/burials/addBurial`;
    let update = `api/burials/updateBurial`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${data?.unicId ? update : create}`;

    let ip = '';
    // דוגמה לשימוש בפונקציה
    await getUserIP().then((myIp) => {
      ip = myIp;
    });

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'burials',
      actionType: data?.id ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data,
    };

    if (!data?.unicId) {
      data = {
        ...data,
        unicId: unicId
      }
    }

    try {
      let res = await addOrUpdateDataEntity2(data, payload, url);

      const tempGrave = context?.contextGraves?.find( g => g?.unicId === data?.graveId)
      

      const updateBurialReq = {...data,
        areaGraveNameHe: tempGrave?.areaGraveNameHe,
        plotId: tempGrave?.plotId,
        blockId: tempGrave?.blockId,
        cemeteryId: tempGrave?.cemeteryId,
        cemeteryNameEn: tempGrave?.cemeteryNameEn,
        cemeteryNameHe: tempGrave?.cemeteryNameHe,
        blockNameEn: tempGrave?.blockNameEn,
        blockNameHe: tempGrave?.blockNameHe,
        plotNameEn: tempGrave?.plotNameEn,
        plotNameHe: tempGrave?.plotNameHe,
        lineNameEn: tempGrave?.lineNameEn,
        lineNameHe: tempGrave?.lineNameHe,
        graveNameHe: tempGrave?.graveNameHe,
        unicId: unicId
        // cancelDate:null,
        // clientFullNameHe:"",
        // contactFullNameHe:null,
        // // createDate:"",
        // deathAbroad:"",
        // documentsList:"",
        // graveComments:"",
        // historyList:"",
        // id:16064,
        // inactiveDate:"",
        // // isActive:1,
        // nationalInsuranceBurial:"",
        // savedGravesList:"",
        // serialBurialId:"",
        // updateDate:"2025-01-20"
      }
      const updateGraveReq = {...tempGrave, graveStatus:3}
      const updateCustomerReq = {...data?.updateCustomer}

      delete updateBurialReq?.updateCustomer;
      delete updateCustomerReq?.updateGrave;

      console.log(6, updateBurialReq);
      console.log(7, updateGraveReq);
      console.log(8, updateCustomerReq);
      

      await updateOrAddItem(db, 'myStore', updateGraveReq, 'dataGraves', 6 );
      await updateOrAddItem(db, 'myStore', updateCustomerReq, 'dataCustomers', 7 );
      await updateOrAddItem(db, 'myStore', updateBurialReq, 'dataBurials', 9 );

      if (res) {

        console.log(1,data);
        console.log(2,payload);

        // const updateBurialReq = {...data}
        // const updateGraveReq = {...data?.updateGrave}
        // const updateCustomerReq = {...data?.updateCustomer}

        // delete updateBurialReq?.updateCustomer;
        // delete updateCustomerReq?.updateGrave;

        // console.log(3, updateBurialReq);
        // console.log(4, updateGraveReq);
        // console.log(5, updateCustomerReq);
        

        // await updateOrAddItem(db, 'myStore', updateGraveReq, 'dataGraves', 6 );
        // await updateOrAddItem(db, 'myStore', updateCustomerReq, 'dataCustomers', 7 );
        // await updateOrAddItem(db, 'myStore', updateBurialReq, 'dataBurials', 9 );

        console.log('התוצאה הצליחה...');
        return res;
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
      return false;
    }
  };

  const removeBurial = async (data) => {
    let query = `api/burials/removeBurial`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
    // removeEntity(id, url)

    try {
      let res = await removeEntity(data, url);
      AllDataBurials();
      if (res) {
        console.log('התוצאה הצליחה...');
        return res;
      } else {
        console.log(res);

        return false;
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
      return false;
    }
  };

  return {
    AllDataBurials,
    addOrUpdateDataBurial,
    removeBurial
  };
};

export default useBurialQueries;
